module.exports = __webpack_public_path__ + "img/no-data1.dcf8c710.png";